import React, { useState, useContext, useCallback, Fragment } from 'react';

import { LocalizationContext, useLocalizedStrings } from 'app/localization/Context';
import { HistoryStackContext } from '../general-components/HistoryStackContext';

import Popup, { usePopup } from '../general-components/Popup/Popup';
import { ChooseAvatar, ChooseLanguage } from './ChooseHomeType';
import { getHomeAvatar } from './HomeList';

import { ReactComponent as IconLanguage } from 'images/profile/language.svg';
import { ReactComponent as IconCamera } from 'images/profile/icon-camera.svg';
import { ReactComponent as IconBackBlack } from 'images/general/back-black.svg';
import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconWarning } from 'images/general/icon-warning-red.svg';
import { ReactComponent as IconTick } from 'images/general/tick.svg';

import { ReactComponent as Avatar1 } from 'images/profile/avatar-1.svg';
import { ReactComponent as Avatar2 } from 'images/profile/avatar-2.svg';
import { ReactComponent as Avatar3 } from 'images/profile/avatar-3.svg';
import { ReactComponent as Avatar4 } from 'images/profile/avatar-4.svg';
import { ReactComponent as Avatar5 } from 'images/profile/avatar-5.svg';
import { ReactComponent as Avatar6 } from 'images/profile/avatar-6.svg';

import './Profile.scss'


export function AskProfile({
    profile, submitProfile, canDismiss,
    dismiss, customSetFullLanguage, useTickForSubmitIcon }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;

    const [isChooseProfilePageActive, setChooseProfilePageActive] = useState(false);
    const isDefaultAvatarValid = (profile.avatar !== undefined) && (profile.avatar !== null) && (profile.avatar > 0);
    const [avatar, setAvatar] = useState(isDefaultAvatarValid ? profile.avatar : 1);
    const isDefaultNameValid = (profile.name !== undefined) && (profile.name !== null) && (profile.name.length > 0);
    const [name, setName] = useState(isDefaultNameValid ? profile.name : "");
    const nextClick = useCallback(() => {
        if (name.length > 1) {
            profile.updateProfileName(name);
            profile.updateProfileAvatar(avatar);
            if (submitProfile)
                submitProfile(name, avatar, l.fullLanguage);
        }
    }, [profile, avatar, name, l.fullLanguage, submitProfile]);

    const setFullLanguage = useCallback((language) => {
        if (customSetFullLanguage) {
            customSetFullLanguage(language);
        } else {
            l.setFullLanguage(language);
        }
    }, [customSetFullLanguage, l]);

    const [isChooseLanguagePageActive, setChooseLanguagePageActive] = useState(false);

    return (
        <div className="new-home-flow-main-content">
            <div className="change-lang" onClick={() => { setChooseLanguagePageActive(true) }} >
                <div className="label">{s.changeLanguage}</div>
                <IconLanguage className="icon" />
            </div>

            {
                canDismiss ? <Fragment>
                    <IconX className="x-icon" />
                    <div className="x-button" onClick={dismiss} />
                </Fragment> : null
            }

            <div className="profile-label">{s.yourProfileInThisHome.header}</div>
            <div className="profile-info-label">{s.yourProfileInThisHome.info}</div>
            {
                (avatar === 1) ? <Avatar1 className="icon" /> :
                    (avatar === 2) ? <Avatar2 className="icon" /> :
                        (avatar === 3) ? <Avatar3 className="icon" /> :
                            (avatar === 4) ? <Avatar4 className="icon" /> :
                                (avatar === 5) ? <Avatar5 className="icon" /> :
                                    (avatar === 6) ? <Avatar6 className="icon" /> : null
            }
            <div className="border">
                <div className="label">
                    {s.changeAvatar}
                </div>
                <IconCamera className="icon" />
            </div>
            <div className="avatar-click-panel" onClick={() => { setChooseProfilePageActive(true) }} />
            <div className="input-label">{s.name}</div>
            <input className="input-box" placeholder={s.namePlaceHolder}
                value={name} onChange={e => setName(e.target.value)}></input>
            <div />

            {!(name.length > 1) ? <div className="error-label">{s.youMustEnterAName}</div> : null}
            <div className="full-blue-button round-button" onClick={nextClick} style={{ zIndex: 0, opacity: (name.length > 1) ? 1 : 0.3 }}>
                {useTickForSubmitIcon ? <Fragment>
                    <div>{s.save}</div> <IconTick className="icon" />
                </Fragment> : <Fragment>
                    <div>{s.next}</div> <IconBackBlack className="icon-180" />
                </Fragment>}
            </div>

            <ChooseAvatar bgClassName={"bg-secondary-color"}
                isActive={isChooseProfilePageActive}
                dismiss={() => setChooseProfilePageActive(false)}
                setAvatar={setAvatar} />

            <ChooseLanguage
                isActive={isChooseLanguagePageActive}
                setFullLanguage={setFullLanguage}
                dismiss={() => setChooseLanguagePageActive(false)} />
        </div>
    )
}

export function AskProfileOverlay({ profile }) {
    const s = useLocalizedStrings();
    const hs = useContext(HistoryStackContext);

    const submitProfile = useCallback((name, avatar, language) => {
        profile.sendChangeProfile({ name, avatar, language });
    }, [profile])

    const [popupId, showPopup, dismissPopup] = usePopup();

    const changeHome = useCallback(() => {
        hs.push("/homes/switch");
    }, [hs]);

    return (
        // <div className="overlay-page">
        <div className="user-management-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <AskProfile
                profile={profile}
                submitProfile={submitProfile}
                useTickForSubmitIcon={true}
                customSetFullLanguage={(language) => { profile.sendChangeProfile({ language }) }}
                canDismiss={true}
                dismiss={showPopup} />

            <Popup popupId={popupId} name="not_filling_profile_popup" baseZIndex={12} dismiss={dismissPopup}>
                <div className="update-popup">
                    <div className="header">
                        {s.yourProfileInThisHome.header}
                    </div>
                    <div className="body red">
                        <IconWarning className="icon" />
                        {s.yourProfileInThisHome.popupInfo}
                    </div>
                    <div className="button blue c1-5" onClick={() => { dismissPopup() }}>
                        {s.yourProfileInThisHome.popupButton}
                    </div>
                    <div className="button light c5-7" onClick={() => { dismissPopup(); setTimeout(() => { changeHome() }) }}>
                        {s.updateNotification.changeHome}
                    </div>
                </div>
            </Popup>
        </div>
        // </div>
    )
}

export function AskHomeProfile({
    defaultName, defaultAvatar, submitHomeProfile, dismiss }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;

    const [isChooseProfilePageActive, setChooseProfilePageActive] = useState(false);
    const [avatar, setAvatar] = useState(defaultAvatar ? defaultAvatar : 5);
    const [name, setName] = useState(defaultName ? defaultName : "");
    const nextClick = useCallback(() => {
        submitHomeProfile(name, avatar);
    }, [submitHomeProfile, avatar, name]);

    return (
        <div className="new-home-flow-main-content">
            <IconX className="x-icon" />
            <div className="x-button" onClick={dismiss} />

            <div className="profile-label">{s.homeProfilePage.createHeader}</div>
            <div className="profile-info-label">{s.homeProfilePage.info}</div>
            {React.createElement(getHomeAvatar(avatar, false), { className: "icon" })}
            <div className="border">
                <div className="label">
                    {s.homeProfilePage.changeAvatar}
                </div>
                <IconCamera className="icon" />
            </div>
            <div className="avatar-click-panel" onClick={() => { setChooseProfilePageActive(true) }} />
            <div className="input-label">{s.name}</div>
            <input className="input-box" placeholder={s.homeProfilePage.homeNamePlaceholder}
                value={name} onChange={e => setName(e.target.value)}></input>
            <div />

            {!(name.length > 1) ? <div className="error-label">{s.youMustEnterAName}</div> : null}
            <div className="full-blue-button round-button" onClick={nextClick} style={{ zIndex: 0, opacity: (name.length > 1) ? 1 : 0.3 }}>
                <div>{s.next}</div> <IconBackBlack className="icon-180" />
            </div>

            <ChooseAvatar forHome={true}
                bgClassName={"bg-secondary-color"}
                isActive={isChooseProfilePageActive}
                dismiss={() => setChooseProfilePageActive(false)}
                setAvatar={setAvatar} />
        </div>
    )
}